module.exports = __webpack_public_path__ + "img/2025-09-19e_3.f7e15141.jpg";